export default __webpack_public_path__ + "static/media/pnsv_stand_Trate.33072eec.png";